import * as React from 'react';
import { sanitizeHTML } from './sanitizeHTML';
export const SanitizeInnerHTMLWrapper = _ref => {
  let {
    children,
    innerHtml
  } = _ref;
  return /*#__PURE__*/React.cloneElement(children, {
    dangerouslySetInnerHTML: {
      __html: sanitizeHTML(innerHtml)
    }
  });
};
//# sourceMappingURL=SanitizeInnerHTMLWrapper.js.map